import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

import styles from './Parser.module.scss';
import { LeaveAlertModal } from 'modules/tt-modals';

export const ContentParser = ({ content }) => {
  const [open, setOpen] = useState(false);
  const [externalLink, setExternalLink] = useState('');

  const cleanHtml = (html) =>
    DOMPurify.sanitize(
      `${html}`
        .replaceAll('<style', '&lt;style')
        .replaceAll('<style>', '&lt;style&gt;')
        .replaceAll('</style>', '&lt;/style&gt;')
        .replaceAll('<form', '&lt;form')
        .replaceAll('<input', '&lt;input')
        .replaceAll('<button', '&lt;button')
        .replaceAll('<select', '&lt;select')
        .replaceAll('<script', '&lt;script')
        .replaceAll('<iframe', '&lt;iframe')
        .replaceAll('<object', '&lt;object')
        .replaceAll('<meta', '&lt;meta')
        .replaceAll('<param', '&lt;param')
        .replaceAll('<html', '&lt;html')
        .replaceAll('<body', '&lt;body')
        .replaceAll('<search', '&lt;search')
        .replaceAll('<noscript', '&lt;noscript')
        .replaceAll('<head', '&lt;head')
        .replaceAll('<base', '&lt;base')
        .replaceAll('<dialog', '&lt;dialog')
        .replaceAll('<footer', '&lt;footer')
        .replaceAll('<header', '&lt;header')
        .replaceAll('<track', '&lt;track')
        .replaceAll('<details', '&lt;details')
        .replaceAll('<source', '&lt;source')
    );

  const renderContent = () => {
    try {
      const contentId = `parsed-content-${content?.length || 1}`;

      return (
        <div className={styles.parserContentWrapper}>
          <div
            id={contentId}
            dangerouslySetInnerHTML={{
              __html: content ? cleanHtml(content) : '',
            }}
          />
        </div>
      );
    } catch (e) {
      return '';
    }
  };

  useEffect(() => {
    if (content) {
      const contentId = `parsed-content-${content?.length || 1}`;

      const contentElement = document.getElementById(contentId);

      if (contentElement) {
        const links = contentElement.getElementsByTagName('a');
        Array.from(links).forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');

            if (href && !href.startsWith('/') && !href.startsWith('#')) {
              setExternalLink(href);
              setOpen(true);
            } else {
              window.location.href = href;
            }
          });
        });
      }
    }
  }, [content]);

  return (
    <>
      {content ? renderContent() : ''}
      <LeaveAlertModal open={open} setOpen={setOpen} externalLink={externalLink} />
    </>
  );
};
